var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tr",
    {
      class: {
        "access-parent-row": _vm.isParent,
        [`theme-${this.$theme.name}`]: _vm.isParent,
      },
    },
    [
      _c(
        "td",
        { style: !_vm.isParent ? { paddingLeft: `${_vm.level * 24}px` } : {} },
        [_vm._v(_vm._s(_vm.permission.name))]
      ),
      _c("td", { staticClass: "has-text-centered" }, [
        _c(
          "div",
          { staticClass: "pretty p-icon p-curve p-smooth p-bigger m-0" },
          [
            _c("input", {
              attrs: { type: "checkbox" },
              domProps: {
                checked: _vm.hasChildren
                  ? _vm.isAllChecked("isBlock")
                  : _vm.permission.isBlock,
              },
              on: {
                change: function ($event) {
                  return _vm.$emit("toggle", {
                    permission: _vm.permission,
                    type: "isBlock",
                    checked: $event.target.checked,
                  })
                },
              },
            }),
            _vm._m(0),
          ]
        ),
      ]),
      _c("td", { staticClass: "has-text-centered" }, [
        _c(
          "div",
          { staticClass: "pretty p-icon p-curve p-smooth p-bigger m-0" },
          [
            _c("input", {
              attrs: { type: "checkbox", disabled: _vm.permission.isBlock },
              domProps: {
                checked: _vm.hasChildren
                  ? _vm.isAllChecked("isRead")
                  : _vm.permission.isRead,
              },
              on: {
                change: function ($event) {
                  return _vm.$emit("toggle", {
                    permission: _vm.permission,
                    type: "isRead",
                    checked: $event.target.checked,
                  })
                },
              },
            }),
            _vm._m(1),
          ]
        ),
      ]),
      _c("td", { staticClass: "has-text-centered" }, [
        _c(
          "div",
          { staticClass: "pretty p-icon p-curve p-smooth p-bigger m-0" },
          [
            _c("input", {
              attrs: { type: "checkbox", disabled: _vm.permission.isBlock },
              domProps: {
                checked: _vm.hasChildren
                  ? _vm.isAllChecked("isAdd")
                  : _vm.permission.isAdd,
              },
              on: {
                change: function ($event) {
                  return _vm.$emit("toggle", {
                    permission: _vm.permission,
                    type: "isAdd",
                    checked: $event.target.checked,
                  })
                },
              },
            }),
            _vm._m(2),
          ]
        ),
      ]),
      _c("td", { staticClass: "has-text-centered" }, [
        _c(
          "div",
          { staticClass: "pretty p-icon p-curve p-smooth p-bigger m-0" },
          [
            _c("input", {
              attrs: { type: "checkbox", disabled: _vm.permission.isBlock },
              domProps: {
                checked: _vm.hasChildren
                  ? _vm.isAllChecked("isEdit")
                  : _vm.permission.isEdit,
              },
              on: {
                change: function ($event) {
                  return _vm.$emit("toggle", {
                    permission: _vm.permission,
                    type: "isEdit",
                    checked: $event.target.checked,
                  })
                },
              },
            }),
            _vm._m(3),
          ]
        ),
      ]),
      _c("td", { staticClass: "has-text-centered" }, [
        _c(
          "div",
          { staticClass: "pretty p-icon p-curve p-smooth p-bigger m-0" },
          [
            _c("input", {
              attrs: { type: "checkbox", disabled: _vm.permission.isBlock },
              domProps: {
                checked: _vm.hasChildren
                  ? _vm.isAllChecked("isDelete")
                  : _vm.permission.isDelete,
              },
              on: {
                change: function ($event) {
                  return _vm.$emit("toggle", {
                    permission: _vm.permission,
                    type: "isDelete",
                    checked: $event.target.checked,
                  })
                },
              },
            }),
            _vm._m(4),
          ]
        ),
      ]),
      _c("td", { staticClass: "has-text-centered" }, [
        _c(
          "div",
          { staticClass: "pretty p-icon p-curve p-smooth p-bigger m-0" },
          [
            _c("input", {
              attrs: { type: "checkbox", disabled: _vm.permission.isBlock },
              domProps: {
                checked: _vm.hasChildren
                  ? _vm.isAllChecked("isPrint")
                  : _vm.permission.isPrint,
              },
              on: {
                change: function ($event) {
                  return _vm.$emit("toggle", {
                    permission: _vm.permission,
                    type: "isPrint",
                    checked: $event.target.checked,
                  })
                },
              },
            }),
            _vm._m(5),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso" }, [_vm._v(" check ")]),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso" }, [_vm._v(" check ")]),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso" }, [_vm._v(" check ")]),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso" }, [_vm._v(" check ")]),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso" }, [_vm._v(" check ")]),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso" }, [_vm._v(" check ")]),
      _c("label"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }